import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";

import temsEagleThumbnail from "../../../../assets/img/caseStudies/TemsEagle.webp";
import temsLogo from "../../../../assets/img/clients/tems-cropped.webp";

export default function TemsEagle() {
    const caseStudy = new CaseStudyTemplate(
        "TEMS Eagle",
        (
            <div>
                <p>
                    A system to record samples during the offshore drilling process and produce daily compliance reports for the purpose of improving  performance, improving efficiencies, reducing waste and lessening the environmental impact.
                </p>

                <p>
                    DEV4 worked with the Engineers of TEMS International Ltd to design a cloud-based application to automate calculations and deliver real-time reporting during the offshore drilling process.
                </p>

                <p>
                    DEV4 gained a deep understanding of the business and the TEMS Eagle requirements from conception and maintain an ongoing relationship with the organisation to support and develop their software applications to ensure they are inline with TEMS International's business growth.
                </p>
            </div>
        ),
        // Project Showcase Thumbnail
        temsEagleThumbnail,
        new Company(
            "TEMS",
            // Company Logo
            temsLogo
        ),
        "https://tems-international.com/tems-international-services/tems-international-eagle-reports",
        [
            technologies.aspNET,
            technologies.telerik,
            technologies.azure,
            technologies.sqlServer
        ]
    )

    return (
        <CaseStudy caseStudy={caseStudy} bgColor="rgba(85, 136, 48, 0.6)"></CaseStudy>
    )
}